import { ContainerJourneyDto, ServiceOrderReportDto } from '@billing/app/api'
import { SelectOption } from '@billing/app/models/select-option.model'
import exportService from '@billing/services/ExportService'
import { CompanyStore } from '@billing/stores/CompanyStore'
import { Dayjs } from 'dayjs'
import { action, computed, makeObservable, observable, runInAction } from 'mobx'

export class CustomerBillingUIStore {
  customerId = ''
  from?: Dayjs
  to?: Dayjs

  billingData: ContainerJourneyDto[] = []
  serviceOrderData: ServiceOrderReportDto[] = []
  isLoading = false

  constructor(private readonly _customerStore: CompanyStore) {
    makeObservable(this, {
      customerId: observable,
      from: observable,
      to: observable,
      billingData: observable,
      isLoading: observable,

      customerOptions: computed,
      setCustomerId: action,
      setFrom: action,
      setTo: action,
      fetchBillingData: action,
    })
  }

  async fetchBillingData() {
    this.isLoading = true
    try {
      const result = await exportService.getContainerBillingData(
        parseInt(this.customerId),
        this.from,
        this.to,
      )
      runInAction(() => {
        this.billingData = result
      })
    } finally {
      runInAction(() => {
        this.isLoading = false
      })
    }
  }

  async fetchServiceOrderData() {
    this.isLoading = true
    try {
      const result = await exportService.getServicesPreBillingData(
        parseInt(this.customerId),
        this.from,
        this.to,
      )
      runInAction(() => {
        this.serviceOrderData = result || []
      })
    } finally {
      runInAction(() => {
        this.isLoading = false
      })
    }
  }

  get customerOptions(): SelectOption[] {
    return this._customerStore.items.map(c => ({ label: c.name, value: c.id }))
  }

  setCustomerId(customerId: string) {
    this.customerId = customerId
  }

  setFrom(from?: Dayjs): void {
    this.from = from
  }

  setTo(to?: Dayjs): void {
    this.to = to
  }

  resetData() {
    this.setCustomerId('')
    this.setFrom(undefined)
    this.setTo(undefined)
    this.billingData = []
    this.serviceOrderData = []
    this.isLoading = false
  }
}
